var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{attrs:{"src":require( '@/assets/images/stage_backgrounds/' + _vm.video ),"poster":require( '@/assets/images/stage_backgrounds/' + _vm.poster ),"autoplay":"","loop":"","muted":""},domProps:{"muted":true}})}
var staticRenderFns = []

export { render, staticRenderFns }